import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { components } from 'src/app/shared/types/api.type';

type OrderInquiryMessage = components['schemas']['OrderInquiryMessageDto'];

/**
 * The conversation of a question about an order (SHIP-1967), oldest message first. The orderer sees it
 * on the order page, the supplier or the Verwaltung in the notification; the reader's own messages sit
 * on the right.
 */
@Component({
  selector: 'app-order-inquiry-thread',
  templateUrl: './order-inquiry-thread.component.html',
  styleUrls: ['./order-inquiry-thread.component.scss'],
  imports: [DatePipe, TranslocoModule]
})
export class OrderInquiryThreadComponent {
  readonly messages = input.required<OrderInquiryMessage[]>();
  /** The side the reader writes for */
  readonly own = input<OrderInquiryMessage['from'] | null>(null);
  /** Stands in for the text of a question asked by its category alone */
  readonly questionLabel = input('');
}
